/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class TagKeyValuesFilters {
  /**
  * Matches if any `{key}={value}` pair in this list is in the `tags` list.
  */
  'containsAllOf'?: Array<string>;
  /**
  * Matches if none of the `{key}={value}` pairs in this list are in the `tags` list.
  */
  'containsAnyOf'?: Array<string>;
  /**
  * Matches if all `{key}={value}` pairs in this list are in the `tags` list.
  */
  'containsNoneOf'?: Array<string>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "containsAllOf",
      "baseName": "containsAllOf",
      "type": "Array<string>",
      "format": ""
    },
    {
      "name": "containsAnyOf",
      "baseName": "containsAnyOf",
      "type": "Array<string>",
      "format": ""
    },
    {
      "name": "containsNoneOf",
      "baseName": "containsNoneOf",
      "type": "Array<string>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return TagKeyValuesFilters.attributeTypeMap;
  }

  public constructor() {
  }
}

